@if (filters$ | async; as filters) {
  <div class="wrapper" [style.visibility]="(isOpen$ | async) ? 'visible' : 'hidden'">
    <div class="backdrop" (click)="setIsOpen(false)">
      <div class="search-container" (click)="$event.stopPropagation()">
        <div class="top">
          <div class="row main">
            <div class="icon-container">
              <mat-icon matPrefix>search</mat-icon>
            </div>
            <div class="input-container">
              <mat-form-field appearance="fill" subscriptSizing="dynamic">
                <input
                  matInput
                  autofocus
                  name="query"
                  [placeholder]="'CALLS.SEARCH_INPUT_PLACEHOLDER' | translate"
                  [ngModel]="query$ | async"
                  (ngModelChange)="queryInput$.next($event)"
                  autocomplete="off"
                  #queryInput
                />
                @if ((query$ | async) !== null) {
                  <mat-icon matSuffix (click)="resetFilters()" class="clickable">cancel_outline</mat-icon>
                }
              </mat-form-field>
            </div>
            <div class="filters-toggle-container">
              <button mat-icon-button (click)="showFilters = !showFilters">
                <mat-icon>filter_list</mat-icon>
              </button>
            </div>
          </div>
          @if (showFilters || anyFiltersApplied(filters, false)) {
            <div class="row">
              <div class="filters">
                <app-filters [filters]="filters" (resetFilters)="resetFilters()"></app-filters>
              </div>
            </div>
          }
        </div>
        @if (anyFiltersApplied(filters)) {
          @if (results$ | async; as result) {
            <div class="results-container">
              @if (result.isPending) {
                <app-spinner></app-spinner>
              } @else if (result.isError) {
                <h2 class="failed-to-load" translate="COMMON.FAILED_TO_LOAD"></h2>
              } @else {
                <div class="left">
                  <app-call-list
                    [calls]="result.data!"
                    callListType="past"
                    (hoverCall)="chosenCall = $event"
                    [activeCall]="chosenCall"
                    [activeMatch]="activeMatch"
                    (click)="handleClickOnSearchResultMeeting()"
                  ></app-call-list>
                </div>
                <div class="right">
                  @if (chosenCall !== null) {
                    @for (match of chosenCall.matches; track match.speakerId) {
                      <a
                        [routerLink]="['/app', 'meetings', chosenCall.id]"
                        [queryParams]="{ mediaTime: toMediaTimePrecision(match.startTimeSeconds), sentenceId: match.sentenceSearchId, isSearchOpen: null }"
                        queryParamsHandling="merge"
                        (mouseenter)="activeMatch = match.sentenceSearchId"
                        (mouseleave)="activeMatch = null"
                        (click)="handleClickOnSearchResultSnippet()"
                      >
                        <div class="match">
                          <span class="speaker">{{ match.speakerName ?? ('COMMON.UNKNOWN' | translate) }}</span
                          >: "<span [innerHTML]="match.sentence" class="content"></span>"
                        </div>
                      </a>
                    }
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  </div>
}
